/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { Amplify } from "aws-amplify";
import awsConfig from "common/configs/awsConfig";

// Redux imports
import { store } from "redux/store";
import { Provider } from 'react-redux';

// Localization library - i18n
import "./i18n";

// Material Dashboard 2 PRO React Context Provider
import { MaterialUIControllerProvider } from "context";

// AWS Amplify configuration
Amplify.configure(awsConfig.Amplify);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
